import { render, staticRenderFns } from "./wenzhengRankingUp.vue?vue&type=template&id=82a6e43c&scoped=true&"
import script from "./wenzhengRankingUp.vue?vue&type=script&lang=ts&"
export * from "./wenzhengRankingUp.vue?vue&type=script&lang=ts&"
import style0 from "./wenzhengRankingUp.vue?vue&type=style&index=0&id=82a6e43c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a6e43c",
  null
  
)

export default component.exports